import { render, staticRenderFns } from "./addUnderLinePay.vue?vue&type=template&id=2bbddf4d&scoped=true"
import script from "./addUnderLinePay.vue?vue&type=script&lang=js"
export * from "./addUnderLinePay.vue?vue&type=script&lang=js"
import style0 from "./addUnderLinePay.vue?vue&type=style&index=0&id=2bbddf4d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbddf4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bbddf4d')) {
      api.createRecord('2bbddf4d', component.options)
    } else {
      api.reload('2bbddf4d', component.options)
    }
    module.hot.accept("./addUnderLinePay.vue?vue&type=template&id=2bbddf4d&scoped=true", function () {
      api.rerender('2bbddf4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/dialog/addUnderLinePay.vue"
export default component.exports